import React from 'react';

import VistaPersonas from '../Compartidas/VistaPersonas';

import ProfesoresCursosHelper from '../../Helpers/ProfesoresCursos';

const HELPER = {
    obtener: ProfesoresCursosHelper.obtenerProfesores,
    obtenerUso: ProfesoresCursosHelper.obtenerUso,
    agregar: ProfesoresCursosHelper.agregarProfesor,
    editar: ProfesoresCursosHelper.editarProfesor,
    eliminar: ProfesoresCursosHelper.eliminarProfesor
};

const USADO_EN = { singular: 'curso', plural: 'cursos' };

const TEXTOS = {
    agregar: 'Agregar profesor',
    editar: 'Editar profesor',
    ayuda: 'Haz clic en un profesor para editarlo. Los que imparten algún curso no se pueden eliminar.',
    buscar: 'Buscar por nombre o certificado',
    vacio: 'Aún no hay profesores de cursos.',
    ubicacion: 'Aparece en las tarjetas de los cursos que imparte y en su página de profesor.',
    certificado: 'Certificado',
    ayudaCertificado: 'Se muestra debajo del nombre, ej. Docente CAAV.',
    enUso: cuantos => `Imparte ${cuantos}. Para eliminarlo, primero asigna otro profesor a esos cursos.`
};

// Las fotos viejas están en profesores_cursos/; las nuevas van a imagenes/profesores-cursos/
const CARPETAS_PROPIAS = ['imagenes%2Fprofesores-cursos%2F', 'profesores_cursos%2F'];

const ProfesoresCursos = () => (
    <VistaPersonas
        helper={HELPER}
        seccion='Cursos'
        encabezado='Profesores de cursos'
        textos={TEXTOS}
        usadoEn={USADO_EN}
        carpeta='imagenes/profesores-cursos/'
        carpetasPropias={CARPETAS_PROPIAS}
        prefijo='profesor'
    />
);

export default ProfesoresCursos;
